import React from 'react';

import MapWrapper from '../../../shared/map/mapWrapper'
import ButtonMediumPrimary from '../../../shared/items/contols/buttonMediumPrimary'

import config from './../../../config.json'

import styles from './intelligenceMapNoData.module.scss'

const IntelligenceMapNoData = props => {
  const { handleClick, showMapControls } = props

  return (
    <div className={!showMapControls ? styles.intelligenceMapNoData : styles.intelligenceMapNoData_disabled}>
      <MapWrapper position={config.defaultMapLocation} />
      {
        showMapControls
          ? <div className={styles.content_container}>
            <div className={styles.message_container}>
              <div className={styles.text_container}>
                <span className={styles.textMessage}>Ошибка данных</span>
              </div>
              <div className={styles.button_container}>
                <ButtonMediumPrimary title="Обновить" handleClick={handleClick} />
              </div>
            </div>
          </div>
          : null
      }
    </div>
  )
}

export default React.memo(IntelligenceMapNoData)